import { isSignupE2eHarness } from "@/lib/e2e/signup-harness"

/**
 * PostHog runs only when NEXT_PUBLIC_POSTHOG_ENABLED is "true" and
 * NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN is set (shared by client and server).
 *
 * Used by server code and `instrumentation-client.ts`. Client components use
 * `lib/posthog-browser.ts`, which duplicates this check (Turbopack HMR); keep in sync.
 * O harness de cadastro desliga aqui. No browser, a cópia olha
 * NEXT_PUBLIC_ASTRA_SIGNUP_E2E — não importe este módulo de um client component.
 */
export function isPostHogEnabled(): boolean {
  if (isSignupE2eHarness()) return false
  if (process.env.NEXT_PUBLIC_POSTHOG_ENABLED !== "true") {
    return false
  }
  const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN?.trim()
  return Boolean(token)
}
